var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignSpeedLimitAdvisoryNar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_advisory_x5F_nar_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_advisory_x5F_nar"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#E2B236"
    },
    d: "M10,6h76c2.209,0,4,1.791,4,4v76c0,2.209-1.791,4-4,4H10 c-2.209,0-4-1.791-4-4V10C6,7.791,7.791,6,10,6z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86,10v76H10V10H86 M86,8H10c-1.105,0-2,0.895-2,2v76c0,1.105,0.895,2,2,2h76c1.105,0,2-0.895,2-2V10 C88,8.895,87.104,8,86,8L86,8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignSpeedLimitAdvisoryNar);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_speed_limit_advisory_nar.47b8034810710c3d41d8d29624435214.svg";
export { ForwardRef as ReactComponent };